import React, { FC } from 'react';
import { Styled } from './';
import { RentalOrderDetailsTableProps } from './ITeroTermsConditionsModal.types';
import { useI18n } from 'contexts/i18n';

const RentalOrderDetailsTable: FC<RentalOrderDetailsTableProps> = ({
  
  currentProposal,
}) => {
  const i18n = useI18n();
  return (
    <Styled.Table>
      <thead>
        <tr>
          <Styled.Th>{i18n['Product(s)']}</Styled.Th>
          <Styled.Th>{i18n['Quantity']}</Styled.Th>
          <Styled.Th>{i18n['Selling Term (No. of months)']}</Styled.Th>
          <Styled.Th>{i18n['Rental List Price']}</Styled.Th>
          <Styled.Th>{i18n['Total Promotions/Discounts']}</Styled.Th>
          <Styled.Th>{i18n['Rental Price/Per month']}</Styled.Th>
          <Styled.Th>{i18n['Total Rental Price']}</Styled.Th>
        </tr>
      </thead>
      <tbody>
        {currentProposal?.lineitems.map(item => (
          <React.Fragment key={item.description}>
            <tr>
              <Styled.Td>
                <div>{item.description}</div>
                {item.softwareType && (
                  <>
                    <br />
                    <div>
                      <strong>{i18n['Software Type']}</strong> {item.softwareType}
                    </div>
                  </>
                )}
              </Styled.Td>
              <Styled.Td>{item.itemSequence}</Styled.Td>
              <Styled.Td>{item.sellingTerm}</Styled.Td>
              <Styled.Td>{item.displayItemUnitPrice}</Styled.Td>
              <Styled.Td>
                {item.promotion?.amount}{' '}
                <div style={{ letterSpacing: '0.1px' }}>
                  {item.promotion?.programName}
                  {item.promotion?.programCode &&
                    `(${item.promotion?.programCode})`}
                </div>
              </Styled.Td>
              <Styled.Td>{item.netUnitPrice}</Styled.Td>
              <Styled.Td>{item.displayItemTotal}</Styled.Td>
            </tr>

            {item?.options?.map(option => (
              <tr key={option.name}>
                <Styled.Td>{option.name}</Styled.Td>
                <Styled.Td>{option.quantity}</Styled.Td>
                <Styled.Td>{option.displayItemUnitPrice}</Styled.Td>
                <Styled.Td></Styled.Td>
                <Styled.Td>{option.displayItemTotal}</Styled.Td>
              </tr>
            ))}
          </React.Fragment>
        ))}
      </tbody>
    </Styled.Table>
  );
};

export default RentalOrderDetailsTable;
